import React, {Fragment} from "react";
import {Container, Row} from "reactstrap";
import {Breadcrumbs} from "../../AbstractElements";
import GreetingCard from "../Component/GreetingCard";
import WidgetsWrapper from "../Component/WidgetsWraper";

const Dashboard = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="Default" parent="Dashboard" title="Default"/>
            <Container fluid={true}>
                <Row className="widget-grid">
                    <GreetingCard/>
                    <WidgetsWrapper/>
                </Row>
            </Container>
        </Fragment>
    );
};

export default Dashboard;
